import React from 'react';
import { StyledAppointmentContent } from './AppointmentContent.styles';

export const AppointmentContent: React.FC = (props) => {
    return <StyledAppointmentContent {...props}/>
};